import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import partial from 'lodash/partial';
import { giveFeedback, dismissFeedback } from 'entries/ducks';
import PositiveFeedback from 'entries/components/positive_feedback';

const validate = (values) => {
  const errors = {};

  if (!values.feedback) {
    errors.feedback = 'Please enter some feedback';
  }

  if (values.feedback && !values.feedback.trim()) {
    errors.feedback = 'Please enter some feedback';
  }

  return errors;
}

const mapDispatchToProps = (dispatch, { item }) => {
  return bindActionCreators({
    onSubmit: partial(giveFeedback, item),
    onHide: dismissFeedback,
  }, dispatch);
}

const PositiveFeedbackForm = reduxForm({
  form: 'REVISION_FEEDBACK_POSITIVE',
  validate,
})(PositiveFeedback);

export default connect(() => ({}), mapDispatchToProps)(PositiveFeedbackForm);



// WEBPACK FOOTER //
// ./entries/containers/positive_feedback.js